export default __webpack_public_path__ + "static/media/img6.f18a97bb.jpg";